<template>
       <div class="root">
        <header>Contact Us</header>
        <p>
            contact <span style="color: blue;">report@habagogo.com</span>
        </p>
    </div>

</template>  

<script>
export default {
  name: "contact",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
    
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
